/**
 * ポーリング設定
 */
export const POLLING_CONFIG = {
  /** ポーリング間隔（ミリ秒） */
  interval: 2000,
  /** 最大リトライ回数 */
  maxRetries: 30,
} as const;

/**
 * ファイルアップロード設定
 */
export const FILE_UPLOAD_CONFIG = {
  /** 許可されるファイルタイプ */
  accept: { 'application/pdf': ['.pdf'] },
  /** 最大ファイルサイズ（20MB） */
  maxSize: 20 * 1024 * 1024,
  /**
   * 最大ページ数（100ページ）
   * Bedrock の Claude 文書解析が 100 ページまでのため、101 ページ以上はアップロード前に弾く
   */
  maxPages: 100,
} as const;
